/** Status UI ↔ label da view / status_id (tabela LCMY_GO_EXPENSE_STATUS usa coluna name) */
export const STATUS_META = {
  pendente: {
    label: 'Pendente',
    short: 'Pend.',
    fg: '#8a5a08',
    bg: '#fff6e6',
    bd: '#f4e0b6',
    dot: '#e0a428',
    darkFg: '#f0c674',
    darkBg: 'rgba(224, 164, 40, 0.16)',
    darkBd: 'rgba(224, 164, 40, 0.34)',
  },
  aprovado: {
    label: 'Aprovado',
    short: 'Aprov.',
    fg: '#10714a',
    bg: '#effaf3',
    bd: '#c6e9d4',
    dot: '#22a06b',
    darkFg: '#6ee7b7',
    darkBg: 'rgba(34, 160, 107, 0.16)',
    darkBd: 'rgba(34, 160, 107, 0.34)',
  },
  revisado: {
    label: 'Revisado',
    short: 'Revis.',
    /* índigo suave (paleta marca) — longe do verde Aprovado e do azul Pago */
    fg: '#4f46a5',
    bg: '#f3f2fb',
    bd: '#d5d2ef',
    dot: '#6d63c9',
    darkFg: '#c4b5fd',
    darkBg: 'rgba(124, 77, 255, 0.16)',
    darkBd: 'rgba(167, 139, 250, 0.32)',
  },
  rejeitado: {
    label: 'Rejeitado',
    short: 'Rejeit.',
    fg: '#a52222',
    bg: '#fdf2f2',
    bd: '#f2cdcd',
    dot: '#d94747',
    darkFg: '#fca5a5',
    darkBg: 'rgba(217, 71, 71, 0.16)',
    darkBd: 'rgba(217, 71, 71, 0.34)',
  },
  negado: {
    label: 'Negado',
    short: 'Neg.',
    /* slate suave — distinto de rejeitado e revisado */
    fg: '#4b5563',
    bg: '#f3f4f6',
    bd: '#d1d5db',
    dot: '#6b7280',
    darkFg: '#c4c4cc',
    darkBg: 'rgba(107, 114, 128, 0.2)',
    darkBd: 'rgba(107, 114, 128, 0.38)',
  },
  pago: {
    label: 'Pago',
    short: 'Pagos',
    fg: '#1f4bb8',
    bg: '#eff4fe',
    bd: '#cddcfb',
    dot: '#3b6fe0',
    darkFg: '#93c5fd',
    darkBg: 'rgba(59, 111, 224, 0.16)',
    darkBd: 'rgba(59, 111, 224, 0.34)',
  },
};

function isDarkThemeActive() {
  if (typeof document === 'undefined') return false;
  return (
    document.documentElement.classList.contains('theme-dark')
    || document.querySelector('.app.theme-dark') != null
  );
}

export function getStatusMeta(statusKey, options = {}) {
  const meta = STATUS_META[statusKey] || STATUS_META.pendente;
  if (options.light || !isDarkThemeActive()) return meta;
  return {
    ...meta,
    fg: meta.darkFg || meta.fg,
    bg: meta.darkBg || meta.bg,
    bd: meta.darkBd || meta.bd,
  };
}

export const DETAIL_TABS = [
  { key: 'todos', label: 'Todos' },
  { key: 'pendente', label: 'Pendentes' },
  { key: 'aprovado', label: 'Aprovados' },
  { key: 'revisado', label: 'Revisados' },
  { key: 'rejeitado', label: 'Rejeitados' },
  { key: 'negado', label: 'Negados' },
  { key: 'pago', label: 'Pagos' },
];

export function formatExpenseDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(`${iso}T12:00:00`)
      .toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' })
      .replace(/\./g, '');
  } catch {
    return String(iso);
  }
}

/** Listagem do detalhe: ocupa menos espaço que "30 de ago de 2026". */
export function formatExpenseDateCompact(iso) {
  if (!iso) return '—';
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  try {
    return new Date(`${iso}T12:00:00`).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return String(iso);
  }
}

/** action API → statusKey UI (otimista) */
export function statusKeyFromAction(action) {
  switch (String(action || '')) {
    case 'approve':
      return 'aprovado';
    case 'pay':
      return 'pago';
    case 'reject_definitive':
      return 'negado';
    case 'reject_review':
      return 'rejeitado';
    default:
      return null;
  }
}
